import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CimClass } from '../../../../models/network-structure.model';
import { NecConnectorSwitchComponent } from '../nec-connector-switch/nec-connector-switch.component';
import { SelectedSubstationForSchematic } from '../../nec-modals/nec-add-new-instance-equipment/nec-add-new-instance-equipment.component';

@Component({
  selector: 'lib-nec-connector-switch-container',
  templateUrl: './nec-connector-switch-container.component.html',
  styleUrls: ['./nec-connector-switch-container.component.scss'],
  standalone: false
})
export class NecConnectorSwitchContainerComponent {
  
switchCimClassOptions: { value: string; text: string } [] = [
  { value: CimClass[CimClass.Jumper], text: 'Jumper' },
  { value: CimClass[CimClass.Fuse], text: 'Fuse' },
  { value: CimClass[CimClass.Disconnector], text: 'Disconnector' },
  { value: CimClass[CimClass.GroundDisconnector], text: 'Ground Disconnector' },
  { value: CimClass[CimClass.Breaker], text: 'Circuit Breaker' },
  { value: CimClass[CimClass.LoadBreakSwitch], text: 'Load Break Switch' }
];

  connectorCimClassOptions: { value: string; text: string } [] = [
    { value: CimClass[CimClass.Busbar], text: 'Busbar'},
    { value: CimClass[CimClass.Junction], text: 'Junction'}
  ];

  groundingAndSectioningCimClassOptions: { value: string; text: string } [] = [
    { value: CimClass[CimClass.Ground], text: 'Ground'},
    { value: CimClass[CimClass.Cut], text: 'Cut'},
  ];

  protectionDevicesCimClassOptions: { value: string; text: string } [] = [
    { value: CimClass[CimClass.Recloser], text: 'Recloser'},
    { value: CimClass[CimClass.Sectionaliser], text: 'Sectionaliser '},
  ];

  compensationEquipmentCimClassOptions: { value: string; text: string } [] = [
    { value: CimClass[CimClass.PetersenCoil], text: 'Petersen Coil'},
    { value: CimClass[CimClass.ShuntCompensator], text: 'Shunt Compensator'},
    { value: CimClass[CimClass.FrequencyConverter], text: 'Frequency Converter'},
    { value: CimClass[CimClass.StaticVarCompensator], text: 'Static Var Compensator '},
  ];

  @ViewChild(NecConnectorSwitchComponent) necConnectorSwitchComponent!: NecConnectorSwitchComponent;
  @Input() type: string | undefined = '';
  @Output() openSubstationSchematic = new EventEmitter<SelectedSubstationForSchematic>();
  cimClassOptions!: { value: string; text: string } [];
  allTypes: {value: string, text: string}[];
  activeItemId = 0;

  constructor() {
    this.allTypes = [
      ...this.switchCimClassOptions,
      ...this.connectorCimClassOptions,
      ...this.groundingAndSectioningCimClassOptions,
      ...this.protectionDevicesCimClassOptions,
      ...this.compensationEquipmentCimClassOptions,
    ].sort((a, b) => a.text.localeCompare(b.text));
  }

  ngOnInit(): void {
    const config = this.getTypeConfig();
    this.cimClassOptions = config.cimClassOptions;
    this.activeItemId = config.activeItemId;
  }

  private getTypeConfig(): {
    cimClassOptions: { value: string; text: string }[];
    activeItemId: number;
  } {
    switch (this.type) {
      case 'connector':
        return {
          cimClassOptions: this.connectorCimClassOptions,
          activeItemId: 3
        };
      case 'switch':
        return {
          cimClassOptions: this.switchCimClassOptions,
          activeItemId: 4
        };
      case 'groundingAndSectioning':
        return {
          cimClassOptions: this.groundingAndSectioningCimClassOptions,
          activeItemId: 18
        };
      case 'protectionDevices':
        return {
          cimClassOptions: this.protectionDevicesCimClassOptions,
          activeItemId: 19
        };
      case 'compensationEquipment':
        return {
          cimClassOptions: this.compensationEquipmentCimClassOptions,
          activeItemId: 20
        };
      default:
        return {
          cimClassOptions: [],
          activeItemId: 0
        };
    }
  }

  openAddModal() {
    this.necConnectorSwitchComponent.openAddModal();
  }
}
